import CostMetricsComponent from './CostMetricsComponent';

export default CostMetricsComponent;
